export enum ListType {
  Action,
  Nav,
  Select,
  Standard
}
